import * as angular from "angular";
import {IController, ITimeoutService} from "angular";
import {SplitService} from "../../services/split-service.service";
import {ExceptionLanguagesType} from "../../types/exception-languages.type";

export class BringozTimeZoneSelectComponent implements IController {
  zoneId: any;
  options: any[];
  isDisabled: boolean;
  ngPlaceholder?: string;
  isRequired: boolean;
  onChange: Function;

  public timeZones: any[];
  public defaultTimeZone: any;

  constructor(private moment, private splitService: SplitService, private $timeout: ITimeoutService) {
    this.defaultTimeZone = this.splitService.getSelectedTimeZone() || this.moment.tz.guess();
  }

  $onInit() {
    if (this.options) {
      this.timeZones = this.options;
    } else {
      const timeZones = this.moment.tz.names();
      const exceptions = Object.values(ExceptionLanguagesType);

      this.timeZones = [];
      this.$timeout(0).then(() => {
        this.timeZones = timeZones.filter(zone => !exceptions.includes(zone));
      })
    }
  }

  $onChanges(changes) {

  }

}

angular
  .module('bringoz.admin.commons')
  .component('bringozTimeZoneSelect', {
    require: {
      form: '^form'
    },
    bindings: {
      zoneId: '<',
      options: '<?',
      isDisabled: '<?',
      ngPlaceholder: '@?',
      isRequired: '<?',
      onChange: '&'
    },
    templateUrl: 'app/modules/commons/components/bringoz-time-zone-select/bringoz-time-zone-select.html',
    controller: BringozTimeZoneSelectComponent
  });
